import { RootState } from 'store';
import { useSelector } from 'react-redux';
import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { DRIVERS_STATE } from '../../constants';

export const useDriverLocations = () => {
  const clientEBoxLocations = useSelector((state: RootState) => state[DRIVERS_STATE].locations.data);
  return clientEBoxLocations;
};

export const useHasDriverLocations = () => {
  const driverLocations = useDriverLocations();
  return !!driverLocations;
};

const useDriverLocationsLoadingStatus = () => {
  const driverLocationsLoadingStatus = useSelector((state: RootState) => state[DRIVERS_STATE].locations.loadingStatus);
  return driverLocationsLoadingStatus;
};

export const useIsDriverLocationsLoading = () => {
  const driverLocationsLoadingStatus = useDriverLocationsLoadingStatus();
  return checkIsLoading(driverLocationsLoadingStatus);
};


export const useIsDriverLocationsDone = () => {
  const driverLocationsLoadingStatus = useDriverLocationsLoadingStatus();
  return checkIsLoadingDone(driverLocationsLoadingStatus);
};